import {
  AdviceScreenshotData,
  CustomerInfo,
} from "Components/Features/CheckPrice/Products/Advice/ProductPrice/AdviceScreenshot/interfaces";
import { EntityTypeOld, ErrorStateOld } from "Store/interfaces/products";

import { AdviceProductDetailsBackendValues } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { AkaAdviceScreenshotData } from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceScreenshot/interfaces";

export interface AdvicePDFState {
  request?: AdditionalAdviceScreenshotData | AdditionalAkaAdviceScreenshotData;
  response: AdvicePDFResponseEntity;
}

export interface AdditionalAdviceScreenshotData extends AdviceScreenshotData {
  readonly customerInfo: CustomerInfo;
  readonly advicePayload: AdviceProductDetailsBackendValues;
  readonly initialAdvice: boolean;
}

export interface AdditionalAkaAdviceScreenshotData
  extends AkaAdviceScreenshotData {
  readonly customerInfo: CustomerInfo;
  readonly advicePayload: AdviceProductDetailsBackendValues;
  readonly initialAdvice: boolean;
}

export interface AdvicePDFStartData {
  ref: HTMLDivElement | null;
  initialAdvice?: boolean;
  throwNewError?: boolean;
}

export interface AkaAdvicePDFStartData extends AdvicePDFStartData {
  adviceType: AdviceType;
}

export enum AdviceType {
  COLLECTIVE,
  INDIVIDUAL,
}

export interface AdvicePDFResponse {
  readonly payload: {
    readonly id: string;
    readonly pdf: string; // Base64 encoded
  };
}

export type AdvicePDFResponseEntity = EntityTypeOld<
  AdvicePDFResponse,
  OperationType
>;

export type AdvicePDFError = ErrorStateOld<OperationType>;

export enum OperationType {
  SAVE_ADVICE_PDF_REQUEST = "SAVE_ADVICE_PDF_REQUEST",
  SAVE_ADVICE_PDF_ERROR = "SAVE_ADVICE_PDF_ERROR",
}
